import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    className as _$cn,
} from 'intact';
import {makeStyles} from './styles';
import {Button, Icon} from 'kpc';

var _$tmp0 = {
    'className': 'icon ion-chevron-right'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {children, mainTitle, subTitle} = this.get();
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$ce(2, 'div', mainTitle, 0),
            _$cc(Button, {
                'type': 'none',
                'icon': true,
                'circle': true,
                'ev-click': this.goHref.bind(this),
                'children': (
                    _$cc(Icon, _$tmp0)
                )
            })
        ], 4, 'title'),
        _$ce(2, 'div', subTitle, 0, 'sub-title'),
        _$ce(2, 'div', children, 0, 'content-box')
    ], 4, _$cn(makeStyles()));
};